import { mapTributes } from './../utils/helpers/tributes';

/* eslint eqeqeq: "off" */

export default {
  tributesGroups: state => mapTributes(state.tributesGroups, state.products)
};
